var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { ContactServices } from '@/service/ContactService';
export const searchContact = (user, searchText, locationId, currentPage = 0) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        let contactsTotal = 0;
        const values = [];
        const filter = {
            locationId: locationId,
            page: currentPage,
            filters: [
                {
                    id: '0a0b9ae3-6469-4078-84b5-fb86c818c093',
                    filterName: 'generic',
                    filterName_lc: 'generic',
                    selectedOption: {
                        filterName: 'generic',
                        filterName_lc: 'generic',
                        condition: 'is',
                        firstValue: searchText,
                        secondValue: 'IN',
                    },
                },
            ],
            sort: [],
            pageLimit: 20,
            justIds: false,
        };
        const response = yield ContactServices.searchContacts(filter);
        if (response.data &&
            response.data.contacts &&
            response.data.contacts.length > 0) {
            response.data.contacts.forEach(element => {
                values.push(transformResponse(element));
            });
            currentPage += 1;
            if (response.data.total) {
                contactsTotal = response.data.total;
            }
            return { contacts: values, contactsTotal: contactsTotal, currentPage };
        }
        return { contacts: values, contactsTotal: contactsTotal, currentPage };
    }
    catch (err) {
        console.log(err);
    }
});
const transformResponse = item => {
    var _a, _b;
    let label = convertCapitalize(item.contactName);
    if (item.email)
        label = label + ' | ' + item.email;
    if (item.phone)
        label = label + ' | ' + item.phone;
    return {
        label: label,
        id: item.id,
        value: `${(_b = (_a = item.contactName) !== null && _a !== void 0 ? _a : item.email) !== null && _b !== void 0 ? _b : item.phone}`,
        firstName: item.firstName,
        lastName: item.lastName,
        email: item.email,
        phone: item.phone,
        conversationId: item.lastConversationId,
    };
};
const convertCapitalize = word => {
    const firstLetter = word.charAt(0);
    const firstLetterCap = firstLetter.toUpperCase();
    const remainingLetters = word.slice(1);
    const capitalizedWord = firstLetterCap + remainingLetters;
    return capitalizedWord;
};
